var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('img',{attrs:{"width":_vm.width,"src":_vm.asset('/images/loaderBalls.svg')}}),_vm._v("\n\tLoading...\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }